<template>
  <div class="case">
    <banner img="../assets/img/bgtop.jpg" title="加入我们" />
    <div class="case-section" v-loading="loading">
      <div class="case-section-content">
        <div class="case-section-content-list" v-for="(cas, index) in caseList" :key="index">
          <img :src="cas.Img" />
          <div class="content-list-abstract" :class="{ 'abstract-active': index % 2 != 1 }">
            <!-- <p class="abstract-title">{{ cas.Title }}</p> -->
            <p class="abstract-title">{{ cas.subTitle }}</p>
            <p class="abstract-content" v-html="cas.Content"></p>
            <!-- <div class="more">
              <router-link class="text-decoration" :to="{ name: 'casedetails', params: { id: cas.Id } }">
                <span>more</span>
                <img src="../assets/img/sanjiao.png" />
              </router-link>
            </div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Banner from "../components/Banner";
export default {
  components: {
    Banner
  },
  data() {
    return {
      loading: true,
      caseList: []
    };
  },
  mounted() {
    window.console.log("case");
    // this.$http
    //   .get("Cases/GetCasesAll")
    //   .then(response => {
    //     //console.log(response);
    this.caseList = [
      {
        Content:
          `<p>【工作内容】</p><p>
        1.协助资产清查工程师进行国有固定资产的清算盘
        点。</p><p>
        2.协助过程中要学习流程和内容</p><p>
        3.整理盘点的内容并且进行账务的核对</p><p>
        4.将完整的数据维护到资产管理系统中。</p><p>
        5.根据要求，将整理完成的资产进行标签化管理</p><p>
        【工作要求】</p><p>
        可以适应出差。</p><p>
        形象良好，头脑聪明，情商在线!!!</p><p>
        熟练运用办公软件，有一定得计算机知识基础。有会计专业相关专业或经验或有会计证，能力强可适当放宽。</p><p>
        必须有良好的沟通能力，不社恐，</p><p>
        【工作时间】</p><p>
        8:30-18:00，中午休息一个半小时，
        一天八小时工作制，不加班。</p><p>
        周末双休，法定节假日带薪休假。</p><p>
        【公司关怀】</p><p>
        不定期举办员工聚餐，五险!过节员工礼品福利年终奖等。</p><p>
        【晋升制度】</p><p>
        公司领导由内部员工晋升，不会空降!付出就会有回报，只要有能力 升职加薪不是梦!</p>`        ,
        CreateTime: "2023-11-30T14:35:52.737",
        Del: null,
        Id: 42,
        Img: "http://www.sdtimo.com/imgs/joinus.png",
        Title: "山东天茂信息科技有限公司欢迎您的加入",
        subTitle: "清查工程师",
      },
      {
        Content:
          `<p>岗位职责</p><p>
        1、负责公司自主版权、成熟管理软件及定制软件销售，负责相关软件服务、搭配硬件的销售:</p><p>
        2、上门拜访的销售模式进行产品销售，负责区域内客户的开拓及管理。</p><p>
        任职要求</p><p>
        专业不限，经验不限，统招专科及以上学历，应、往届生均可;</p><p>
        2、热爱营销工作，有一定的抗压能力，可适应省内外出差。</p><p>
        【工作时间】</p><p>
        8:30-18:00，中午休息一个半小时，</p><p>
        一天八小时工作制，不加班。</p><p>
        周末双休，法定节假日带薪休假。</p><p>
        【公司关怀】</p><p>
        不定期举办员工聚餐，五险!过节员工礼品福利年终奖等。</p><p>
        【晋升制度】</p><p>
        公司领导由内部员工晋升，不会空降!付出就会有回报，只要有能力 升职加薪不是梦!</p>`        ,
        CreateTime: "2023-11-30T14:35:52.737",
        Del: null,
        Id: 42,
        Img: "http://www.sdtimo.com/imgs/joinus.png",
        Title: "山东天茂信息科技有限公司欢迎您的加入",
        subTitle: "销售专员",
      }
    ]
    //     //window.console.log(this.caseList);
    this.loading = false;
    //   })
    //   .catch(function(error) {
    //     window.console.log(error);
    //   });
  }
};
</script>

<style lang="scss" scoped>
.case {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-color: #14679f;

  &-section {
    width: 100%;

    &-content {
      width: 1240px;
      min-height: 550px;
      margin: 0 auto;
      background-color: #fff;

      &-list {
        width: 100%;
        height: 550px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid pink;

        img {
          width: 500px;
          height: 314px;
        }

        .content-list-abstract {
          width: 400px;
          // height: 350px;
          padding: 0 20px;
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .abstract-title {
            line-height: 30px;
            font-size: 22px;
            margin: 10px 0;
            color: #e13834;
          }

          .abstract-content {
            // height: 150px;
            color: #484848;
            font-size: 15px;

            // overflow: hidden;
            // text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 7;
            // -webkit-box-orient: vertical;
            // white-space: normal !important;
            // word-wrap: break-word;
            //border: 1px solid pink;
          }

          .more {
            display: flex;
            justify-content: flex-start;

            .text-decoration {
              text-decoration: none;

              span {
                color: #000;
              }

              img {
                width: 12px;
                height: 12px;
              }
            }
          }
        }

        .abstract-active {
          order: -1;
        }
      }
    }
  }
}
</style>